import {
    Box,
    Image as ChakraImage,
    ImageProps as ChakraImageProps,
} from '@chakra-ui/react';
import React, { useState } from 'react';

export type ImageProps = {
    url?: string
} & ChakraImageProps & React.RefAttributes<HTMLImageElement>;

export const Image: React.FC<ImageProps> = ({
    url,
    ...props
}) => {
    const [loaded, setLoaded] = useState(false);
    return (
        <>
            <ChakraImage
                display={loaded ? 'block' : 'none'}
                src={url}
                onLoad={() => setLoaded(true)}
                onError={() => setLoaded(true)}
                {...props}
            />
            <Box
                display={loaded ? 'none' : 'block'}
                {...props}
                background="#D9D9D9"
            />
        </>
    );
};
